export default __webpack_public_path__ + "static/media/bart.78bcb4e5.svg";